var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 20,
    viewBox: "0 0 53 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9567 15.633V9.77053V9.76937H28.1281C29.4356 9.77014 30.5345 9.35929 31.4247 8.53681C32.3243 7.75622 32.8273 6.63389 32.8017 5.46405C32.8195 4.30071 32.3175 3.1867 31.4247 2.40863C30.5423 1.58165 29.3555 1.13043 28.1281 1.15527H23.0371V15.633H24.9567ZM24.9566 7.99157V2.9377V2.93654H28.1758C28.8932 2.917 29.5848 3.19674 30.075 3.70473C30.5682 4.1693 30.8465 4.80742 30.8465 5.47387C30.8465 6.14033 30.5682 6.77844 30.075 7.24302C29.5788 7.74032 28.8893 8.01206 28.1758 7.99157H24.9566Z",
    fill: "#646464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5851 6.50633C39.764 5.77164 38.6441 5.4043 37.2253 5.4043C35.4027 5.4043 34.0265 6.05119 33.0965 7.34498L34.7871 8.37655C35.4119 7.50016 36.2604 7.06197 37.3326 7.06197C38.0162 7.05421 38.6778 7.29632 39.1854 7.74005C39.6915 8.14547 39.9826 8.74991 39.9782 9.38617V9.81127C39.2406 9.40696 38.3019 9.20481 37.1621 9.20481C35.8268 9.20635 34.7593 9.50977 33.9597 10.1151C33.1601 10.7204 32.7603 11.5356 32.7603 12.5606C32.7429 13.4939 33.1607 14.3851 33.8977 14.9864C34.656 15.6333 35.5983 15.9568 36.7246 15.9568C38.044 15.9568 39.1011 15.3907 39.896 14.2587H39.9794V15.6333H41.8155V9.52825C41.8163 8.24832 41.4062 7.24102 40.5851 6.50633ZM35.3785 13.8139C34.9764 13.5331 34.7392 13.0813 34.7418 12.601C34.7418 12.0615 35.0029 11.6122 35.5287 11.2425C36.0493 10.8783 36.6995 10.6961 37.4793 10.6961C38.5499 10.6961 39.3845 10.9272 39.983 11.3892C39.983 12.1701 39.6651 12.8505 39.0292 13.4304C38.4565 13.9854 37.68 14.2978 36.87 14.2991C36.33 14.3089 35.803 14.1375 35.3785 13.8139Z",
    fill: "#646464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3561 5.72754L45.9465 19.9997H43.965L46.3436 15.0059L42.1289 5.72754H44.2154L47.2616 12.8434H47.3033L50.2661 5.72754L52.3561 5.72754Z",
    fill: "#646464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2003 8.50757C17.2011 7.94079 17.1516 7.375 17.0525 6.81641H8.95703V10.0197H13.5937C13.402 11.0535 12.7827 11.9666 11.8793 12.5472V14.6265H14.6465C16.2668 13.1791 17.2003 11.0386 17.2003 8.50757Z",
    fill: "#646464"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95693 16.6346C11.2735 16.6346 13.224 15.8976 14.6464 14.6269L11.8792 12.5476C11.109 13.0536 10.117 13.3423 8.95693 13.3423C6.71786 13.3423 4.8174 11.8799 4.13781 9.90918H1.28711V12.052C2.74424 14.8613 5.71186 16.6344 8.95693 16.6346Z",
    fill: "#646464"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.13782 9.9095C3.77855 8.87683 3.77855 7.75852 4.13782 6.72585V4.58301H1.28712C0.0683555 6.93277 0.0683555 9.70257 1.28712 12.0523L4.13782 9.9095Z",
    fill: "#646464"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95693 3.29278C10.1811 3.2734 11.364 3.72155 12.25 4.54036L14.7001 2.16649C13.1464 0.752649 11.0882 -0.0235732 8.95693 0.000545688C5.71186 0.000688984 2.74424 1.77378 1.28711 4.5831L4.13781 6.72594C4.8174 4.75522 6.71786 3.29278 8.95693 3.29278Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.95c15f170c64d8b7c223cb52f1441b27.svg";
export { ForwardRef as ReactComponent };